export const energyLaptop = require('./energy-laptop.png');
export const usEnergySolutions = require('./usEnergySolutions.png?webp');
export const ledServices = require('./ledServices.png');
export const gridOptimization = require('./gridOptimization.png');
export const gridOptimization2x = require('./gridOptimization2x.png');
export const solarEnergy = require('./solarEnergy.png');
export const solarEnergy2x = require('./solarEnergy2x.png');
export const demandResponseImage = require('./demandResponse.png?webp');
export const findAll = require('./findAll.png?webp');
export const evApartmentsImage = require('./ev-appartments.jpg?webp');
export const evCarsChargingImage = require('./cars-charging.jpg?webp');
export const evManChargingImage = require('./ev-man-charging.jpg?webp');
export const bgPhone = require('./bgPhone.png?webp');
export const bgPhone2x = require('./bgPhone2x.png?webp');
export { default as triangleShadow } from './triangle-shadow.svg';
